      <!-- End of Record Details -->
      <mat-divider></mat-divider>

      <!-- LTID Details -->
      @if(caisServiceService.hasAnyActiveField(LTIDGridColumns)) {
        <mat-list-item class="cais-list-item-title">LTID Details</mat-list-item>
        <div class="ui-grid-col-12 container">
          <p-table id="EditLTIDTable" [columns]="LTIDGridColumns" [value]="this.caisServiceService.LTIDDataSet" class="LTIDDTTable">
            <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
              <tr>
                <th id="LTIDHeader"></th>
                @for(col of columns; track col; let i = $index){
                <th id="ui_columnname" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  {{col.ui_columnname}}
                </th>
              }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
                <td class="text-center">
                  @if((this.caisServiceService.LTIDDataSet.length === (rowIndex+1))){
                  <a [ngClass]="{'disabledLink': true, 'ltid-table-row-button': true}" (click)="addLTID();" matTooltip="Add New Record"
                    [matTooltipShowDelay]="1000" matTooltipPosition="after">
                    <em class="pi pi-plus"></em>
                  </a>
                }
                  <a [ngClass]="{'disabledLink': true, 'ltid-table-row-button': true}" (click)="removeLTID(rowIndex);" matTooltip="Remove Record" [matTooltipShowDelay]="1000"
                    matTooltipPosition="after">
                    <em class="pi pi-minus"></em>
                  </a>
                </td>
                @for(col of columns; track col; let i = $index){
                <td pEditableColumn class="ui-resizable-column" [ngClass]="{'notdisplay':((col?.display | lowercase) == 'false'), 'errorFieldBorderBottom':(row['errorFields'] && row['errorFields'][col.mappingkey])}">
                  <p-cellEditor>
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [id]="row[col.mappingkey]+'string'" [(ngModel)]="row[col.mappingkey]" [placeholder]="(col.placeholder ? col.placeholder : '')"
                        [disabled]="col.disabled" [title]="(col.placeholder ? col.placeholder : '')">
                    </ng-template>
                  }
                  @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="input">
                      <p-datepicker
                        inputId="basic"
                        [touchUI]="true"
                        [placeholder]="(col.placeholder ? col.placeholder : '')"
                        [(ngModel)]="row[col.mappingkey]" 
                        [disabled]="col.disabled"
                        dateFormat="yy-mm-dd"
                        appendTo="body"
                        placeholder="YYYY-MM-DD"
                        [motionOptions]="{ duration: 0 }"
                      ></p-datepicker>
                      </ng-template>
                    }
                    @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){  
                    <ng-template pTemplate="input">
                      <p-select appendTo="body" [name]="row[col.mappingkey]+'singleselect'" [id]="row[col.mappingkey]+'singleselect'" 
                        [options]="col.dropdownvalue"  [filter]="true" [(ngModel)]="row[col.mappingkey]" [disabled]="col.disabled" [showClear]="true" 
                        [placeholder]="'Enter Value'" class="maxChoiceWidth"
                        styleClass = "ltid-record-form-dropdown">
                      </p-select>
                    </ng-template>
                  }
                  @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                    <ng-template pTemplate="output">
                        {{row[col.mappingkey]}}
                    </ng-template>
                  }
                  @if((col?.datatype | lowercase) === 'date'){
                    <ng-template pTemplate="output">
                      {{this.userService.getUTCDate_yyyyMMdd(row[col.mappingkey])}}
                    </ng-template>
                  }
                  @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                    <ng-template pTemplate="output">
                      {{row[col.mappingkey]}}
                    </ng-template>
                  }
                  </p-cellEditor>
                </td>
              }
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      <!-- End of LTID Details -->